import React from "react";
import Logo from "./img/logo-glavnoe.svg";

export default function Header({ categories }) {
    return (
        <header className="header header_glavnoe js-header">
            <div className="header__inner inner-sm">
                <button className="btn-nav js-btn-nav" type="button">
                    <span className="btn-nav__line" />
                    <span className="btn-nav__line" />
                    <span className="btn-nav__line" />
                </button>

                <a href="/" className="logo">
                    <h1 className="logo__hide">24сми</h1>
                    <img src={Logo} alt="logo" />
                </a>

                <div className="nav nav_glavnoe js-nav">
                    <ul className="nav__list">
                        {categories.map(category => (
                            <li className="nav__item" key={category.id}>
                                <a href={category.url} className="nav__link ">
                                    {category.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </header>
    );
}
